import * as React from 'react';

import { PropertyRoomScoreTagsModel } from 'models';

import { GuestRoomScoreItem } from 'components/infosite/rooms-and-rates/guest-room-score-item';

interface GuestLikeItForListProps {
  guestLikeItForTags: PropertyRoomScoreTagsModel[];
}

export class GuestLikeItForList extends React.Component<GuestLikeItForListProps> {
  public render() {
    const { guestLikeItForTags } = this.props;

    if (!guestLikeItForTags || guestLikeItForTags.length === 0) {
      return null;
    }

    return guestLikeItForTags.map(guestLikeItForTagsOption => (
      <GuestRoomScoreItem
        key={guestLikeItForTagsOption.label}
        roomScoreCriteriaAndCount={guestLikeItForTagsOption.label}
        isTextLocalized={true}
      />
    ));
  }
}
